var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "team-view mt-3" },
    [
      _c(_setup.ConfirmationModal, {
        attrs: {
          value: _setup.modalValues.show,
          title: _setup.modalValues.title,
          "action-verb": _setup.modalValues.actionVerb,
        },
        on: {
          ok: function ($event) {
            _setup.modalValues.action ? _setup.modalValues.action() : null
          },
          cancel: function ($event) {
            _setup.modalValues.show = !_setup.modalValues.show
          },
        },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_setup.modalValues.description),
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _setup.showAddMemberModal
        ? _c(_setup.CreateMemberModal, {
            on: {
              "member-created": _setup.assignMemberHandler,
              "handle-permissions": _setup.assignMemberPermissionsHandler,
              cancel: _setup.cancelMemberHandler,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.showUpdateMemberModal && _setup.selectedMember
        ? _c(_setup.UpdateMemberModal, {
            attrs: { member: _setup.selectedMember },
            on: {
              "member-updated": _setup.onMemberUpdateHandler,
              "handle-permissions": _setup.assignMemberPermissionsHandler,
              cancel: _setup.cancelMemberUpdateHandler,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.showMemberAccessModal && _setup.selectedMember
        ? _c(_setup.MemberAccessModal, {
            attrs: {
              member: _setup.selectedMember,
              "entity-type": _setup.selectedEntityType,
            },
            on: {
              "permissions-saved": _setup.onPermissionsUpdated,
              "member-updated": _setup.onMemberUpdated,
              cancel: _setup.cancelMemberPermissionsHandler,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "members-section" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12 col-lg-8 team-wrapper" },
            [
              !_setup.user?.ImpersonatedFromChildUser
                ? _c(
                    "div",
                    { staticClass: "mt-3 d-flex justify-content-between" },
                    [
                      _c("b-form-input", {
                        staticClass: "search-input-gray w-50 h-100",
                        attrs: {
                          type: "text",
                          debounce: "400",
                          placeholder: "Search",
                        },
                        model: {
                          value: _setup.searchString,
                          callback: function ($$v) {
                            _setup.searchString = $$v
                          },
                          expression: "searchString",
                        },
                      }),
                      _vm._v(" "),
                      _c(_setup.CButton, {
                        attrs: { text: "Add member", variant: "primary" },
                        on: { click: _setup.openCreateModal },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(_setup.TeamTable, {
                staticStyle: { "background-color": "white" },
                attrs: { members: _setup.teamMembers },
                on: {
                  "edit-member": _setup.onMemberEditHandler,
                  "manage-member-entity-access":
                    _setup.assignMemberEntitiesHandler,
                  "delete-member": _setup.toggleDeleteModal,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [
                  _setup.totalCount / _setup.itemsPerPage > 1
                    ? _c("b-pagination", {
                        attrs: {
                          size: "md",
                          "total-rows": _setup.totalCount,
                          "per-page": _setup.itemsPerPage,
                        },
                        model: {
                          value: _setup.currentPage,
                          callback: function ($$v) {
                            _setup.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-md-12 col-lg-4" }, [
      _c("h2", [_vm._v("Members")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n                    In this section, you can provide "Member" access to other members, allowing them to view and\n                    interact with specific features of the app. This access enables them to contribute to projects,\n                    share insights, and collaborate effectively while maintaining control over sensitive settings.\n                '
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }